const transformV2Banners = (banners) => {
  const basePath = "/media";

  const getImageObject = (filePath, link) => ({
    link: link || "/",
    file: basePath + filePath,
  });

  const result = {
    id: banners.id || "",
    name: banners.name || "",
    position: banners.position || "",
    images: [],
    images_mobile: [],
    images_tablet: [],
  };

  banners.images.forEach((item) => {
    if (item.file) {
      result.images.push(getImageObject(item.file, item.url));
    }

    if (item.file_mobile) {
      result.images_mobile.push(getImageObject(item.file_mobile, item.url));
    }

    if (item.file_tablet) {
      result.images_tablet.push(getImageObject(item.file_tablet, item.url));
    }
  });

  return result;
};

export default transformV2Banners;
